import styled from '@emotion/styled';

/**
 * Shared pill-shaped view toggle used in Impact Path, Pivot Points, Lenses, and Solutions.
 */
export const ViewModeSelector = styled.div`
  display: flex;
  gap: 0;
  height: 32px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  overflow: hidden;
`;

export const ViewModeButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  height: 100%;
  padding: 0 14px;
  background: ${props => props.$active ? 'rgba(33, 150, 243, 0.4)' : 'transparent'};
  border: none;
  color: white;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: ${props => props.$active ? 'rgba(33, 150, 243, 0.5)' : 'rgba(255, 255, 255, 0.1)'};
  }

  &:not(:last-child) {
    border-right: 1px solid rgba(255, 255, 255, 0.2);
  }

  svg {
    width: 14px;
    height: 14px;
    opacity: 0.8;
  }
`;
